import lottie from 'lottie-web';

class LottieAnimations {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-trust]',
			basePath: './image/animation/',
			speeds: {
				'trust-1': 0.6,
				'trust-4': 1.4,
			},
		}, config);

		this.items = [];
		this.observer = null;
		this.scope = document.querySelectorAll(this.config.scope);

		if (this.scope.length > 0) {
			this.renderer = this.#getOptimalRenderer();
			// console.log('Lottie renderer:', this.renderer);

			this.init();
		}
	}

	#getOptimalRenderer() {
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'canvas';
		if (!navigator.deviceMemory || navigator.deviceMemory < 4) return 'canvas';

		return 'svg';
	}

	init() {
		const isSvg = this.renderer === 'svg';

		this.scope.forEach((el) => {
			const name = el.getAttribute('data-trust');
			const speed = parseFloat(el.getAttribute('data-trust-speed')) || this.config.speeds[name] || null;

			const anim = lottie.loadAnimation({
				container: el,
				renderer: this.renderer,
				loop: true,
				autoplay: false,
				path: `${this.config.basePath}${name}.json`,
				rendererSettings: isSvg ? {} : {
					dpr: window.devicePixelRatio || 1,
				},
			});

			anim.addEventListener('DOMLoaded', () => {
				if (speed) anim.setSpeed(speed);
				anim.setSubframe(false);
			});

			this.items.push({ element: el, animation: anim });
		});

		this.observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const match = this.items.find(item => item.element === entry.target);
				if (!match) return;
				entry.isIntersecting ? match.animation.play() : match.animation.stop();
			});
		}, { threshold: 0 });

		this.items.forEach(item => this.observer.observe(item.element));
	}
}

export default new LottieAnimations();
